import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PointOfSaleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"point_of_sale"}/>
}
